import React from 'react';
import {usePolTranslation} from "v4/hooks/usePolTranslation";

export default function DefaultCrudNotFound() {
    const {t} = usePolTranslation();
    return (
        <p>{t('page_not_found')}</p>
    )
}
